import { GET_ITEM_DELIVERY_SUMMARY } from '../actionTypes/OrderActionTypes';

export const getItemDeliverySummary = (payload) => ({
    type: GET_ITEM_DELIVERY_SUMMARY,
    payload,
});

export default getItemDeliverySummary;
